import styled from '@emotion/styled';
import IosShareIcon from '@mui/icons-material/IosShare';
import React from 'react';

import { projectRouteUtil } from '~/client/routes';
import {
  QuickActionButton,
  QuickActionDrawer,
} from '~c/components/base/quick-action';

interface Props {
  className?: string;
}

const ReportGenerationRightPanel: React.FC<Props> = ({ className }) => {
  const { navigateTo } = projectRouteUtil.useHelper();

  return (
    <div className={className}>
      <QuickActionDrawer header={{ text: 'QUICK ACTIONS' }}>
        <QuickActionButton
          icon={IosShareIcon}
          onClick={() => navigateTo('DASHBOARD')}
        >
          Submit
        </QuickActionButton>
      </QuickActionDrawer>
    </div>
  );
};

export default styled(ReportGenerationRightPanel)`
  @media print {
    display: none;
  }
`;
